import { UnitSystem } from './unit-system-enum';

export enum MeasurementUnits {
    NONE,
    LEVELS,
    PERCENT,
    FEET,
    SQUARE_FEET,
    SPACES_PER_UNIT,
    SPACES_PER_AREA,
    SPACES_PER_PERSON,
    PEOPLE,
    UNITS,
    DU_PER_ACRE
}

const imperialLabels = [
    '',
    'Levels',
    '%',
    'ft',
    'ft²',
    'spaces/unit',
    'spaces/area',
    'spaces/person',
    'people',
    'units',
    'du/acre'
];

const metricLabels = [
    '',
    'Levels',
    '%',
    'm',
    'm²',
    'spaces/unit',
    'spaces/area',
    'spaces/person',
    'people',
    'units',
    'du/ha'
];

export function getMeasurementUnitsTitle(value: number, unitSystem: UnitSystem = UnitSystem.IMPERIAL): string {
    return (unitSystem === UnitSystem.METRIC ? metricLabels : imperialLabels)[value];
}
